import React from "react";
import { cn, Typography } from "@semo/shared-ui";
import { CheckCircle2 } from "@semo/icons";
import { MessageLayout } from "../layout/MessageLayout";
import { MessageCardWrapper } from "../layout/MessageCardWrapper";
import type { ChatMessageProps } from "../types";
import type { ReviewSubmittedMessageResponseDto } from "@semo/api-contracts";
import type { LocalMessageState } from "../../types/message";

interface ReviewSubmittedMessageProps extends Omit<
  ChatMessageProps,
  "message"
> {
  message: ReviewSubmittedMessageResponseDto & LocalMessageState;
  sender: "me" | "other";
  time: string;
}

export const ReviewSubmittedMessage: React.FC<ReviewSubmittedMessageProps> = ({
  message,
  sender,
  partyName,
  time,
  showAvatar = true,
  showName = true,
}) => {
  const { isRead, isPending, isError } = message;

  if (!message.reviewSubmittedData) return null;

  return (
    <MessageLayout
      sender={sender}
      partyName={partyName}
      time={time}
      isRead={isRead}
      isPending={isPending}
      isError={isError}
      showAvatar={showAvatar}
      showName={showName}
      variant="card"
    >
      <MessageCardWrapper
        className={cn(
          "bg-white border rounded-xl p-3 sm:p-4 shadow-sm",
          sender === "me" ? "border-primary/15" : "border-slate-200",
        )}
      >
        <div className="flex flex-col items-center text-center space-y-3">
          <div className="w-10 h-10 rounded-full bg-primary/5 flex items-center justify-center">
            <CheckCircle2 className="w-5 h-5 text-primary-text" />
          </div>

          <div className="space-y-1">
            <Typography
              variant="body-sm"
              className="font-semibold text-gray-900"
            >
              구매확정 완료
            </Typography>
            <Typography
              variant="caption"
              className="text-gray-500 leading-relaxed"
            >
              구매확정 및 리뷰 작성이 완료되었습니다.
              <br />
              소중한 의견 감사합니다.
            </Typography>
          </div>
        </div>
      </MessageCardWrapper>
    </MessageLayout>
  );
};
